import React from "react";

type Team = {
  id: number;
  name: string;
  level: string;
  players: number | string;
  coach: string;
  captain: string;
  founded: string;
  achievements: string[];
  image: string;
  schedule: string;
};

export const TeamsGrid: React.FC = () => {
  const teams: Team[] = [
    {
      id: 1,
      name: "4x4 Équi-mixte",
      level: "Poule 4",
      players: 6,
      coach: "JC",
      captain: "JC",
      founded: "2018",
      achievements: ["a fini tous ses championnats"],
      image: "/src/assets/teams/equi-mixte.jpg", // mets tes photos d’équipe ici
      schedule: "Lundi et Mercredi 20h-22h",
    },
    {
      id: 2,
      name: "Seniors Féminines A (4x4)",
      level: "Poule 2",
      players: 7,
      coach: "MagicToto",
      captain: "Claire",
      founded: "2023",
      achievements: ["Vice-championne poule 3 2024/2025"],
      image: "/src/assets/teams/seniors-feminines-a.jpg",
      schedule: "Samedi 9h00-11h00",
    },
    {
      id: 3,
      name: "Équipe 4x4",
      level: "Poule 2",
      players: 8,
      coach: "Freddy",
      captain: "Tous",
      founded: "2025",
      achievements: ["en construction"],
      image: "/src/assets/teams/equipe-4x4.jpg",
      schedule: "Mercredi 21h-23h",
    },
    {
      id: 4,
      name: "Équipe Jeunes 1",
      level: "Accès",
      players: 14,
      coach: "Claire",
      captain: "aucun",
      founded: "2023",
      achievements: ["Champion de France 2024/2025"],
      image: "/src/assets/teams/jeunes-1.jpg",
      schedule: "Samedi 11h-13h00",
    },
    {
      id: 5,
      name: "Équipe Jeunes 2",
      level: "Promotion",
      players: 12,
      coach: "Sacha",
      captain: "aucun",
      founded: "2023",
      achievements: ["Esprit Sportif – Award"],
      image: "/src/assets/teams/jeunes-2.jpg",
      schedule: "Samedi 11h-13h00",
    },
  ];

  const playersLabel = (p: Team["players"]) =>
    typeof p === "number" ? `${p} joueur${p > 1 ? "s" : ""}` : p;

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Toutes nos équipes
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Le CSVBV compte {teams.length} équipe{teams.length > 1 ? "s" : ""} évoluant à différents niveaux,
            offrant des opportunités pour tous les profils de joueurs.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {teams.map((team) => (
            <div
              key={team.id}
              className="bg-gray-50 rounded-xl overflow-hidden hover:shadow-xl transition-shadow duration-300"
            >
              <div className="md:flex">
                <div className="md:w-1/2">
                  <img
                    src={team.image}
                    alt={`Photo de ${team.name}`}
                    className="w-full h-64 md:h-full object-cover object-center"
                    loading="lazy"
                  />
                </div>
                <div className="md:w-1/2 p-6">
                  <div className="flex items-center justify-between mb-3">
                    <h3 className="text-xl font-bold text-gray-900">{team.name}</h3>
                    <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium">
                      {team.level}
                    </span>
                  </div>

                  <div className="space-y-3 mb-4">
                    <div className="flex items-center text-gray-600">
                      <i className="ri-user-star-line mr-2 text-blue-600 w-5" />
                      <span className="text-sm">Coach : {team.coach}</span>
                    </div>
                    <div className="flex items-center text-gray-600">
                      <i className="ri-shield-star-line mr-2 text-blue-600 w-5" />
                      <span className="text-sm">Capitaine : {team.captain}</span>
                    </div>
                    <div className="flex items-center text-gray-600">
                      <i className="ri-group-line mr-2 text-blue-600 w-5" />
                      <span className="text-sm">{playersLabel(team.players)}</span>
                    </div>
                    <div className="flex items-center text-gray-600">
                      <i className="ri-time-line mr-2 text-blue-600 w-5" />
                      <span className="text-sm">{team.schedule}</span>
                    </div>
                  </div>

                  <div className="mb-4">
                    <h4 className="font-semibold text-gray-900 mb-2">Palmarès récent :</h4>
                    <ul className="space-y-1">
                      {team.achievements.map((a, i) => (
                        <li key={i} className="text-sm text-gray-600 flex items-center">
                          <i className="ri-trophy-line mr-2 text-yellow-500 w-4" />
                          {a}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-500">Fondée en {team.founded}</span>
                    <i className="ri-volleyball-line text-blue-600 text-xl" />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamsGrid; // export par défaut AUSSI
